// extracted by mini-css-extract-plugin
export default {"button":"folders_button__-Lbtp","headFont":"folders_headFont__fvlXa","modalFolder":"folders_modalFolder__y6-NT","modalBody":"folders_modalBody__MoFRN"};